module.exports = __webpack_public_path__ + "img/c83552d.jpg";